import React, { useMemo, useState, useEffect } from 'react';
import { useGiftCardBalance } from '@olo-web/domain/giftcard';
import { GiftCardView } from './GiftCardView';
import { GiftCardInput } from './GiftCardInput';
import { VisuallyHidden } from '@chakra-ui/react';

export const GiftCard = (props) => {
  const { data } = useGiftCardBalance();
  const [showGiftcardAlert, setShowGiftcardAlert] = useState(false);
  const validGiftCardExists = useMemo(() => {
    if (!data) return false;
    return +data.remainingBalanceAmount > 0;
  }, [data]);
  useEffect(() => {
    if (validGiftCardExists && !showGiftcardAlert) {
      setShowGiftcardAlert(true);
    }
  }, [showGiftcardAlert, validGiftCardExists]);

  if (validGiftCardExists)
    return (
      <>
        <VisuallyHidden
          role="alert"
          aria-live="assertive"
          display={showGiftcardAlert ? 'block' : 'none'}
        >
          Gift card was added
        </VisuallyHidden>
        <GiftCardView {...props} />
      </>
    );

  return <GiftCardInput />;
};
